<template>
  <lazy-div>
    <message :messages="messages"></message>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 class="ma-0 pa-0">
          <v-card-actions>
            <v-spacer/>
            <v-btn @click="showClmts = true">
              <v-icon>mdi-account-multiple</v-icon>
              <span style="padding-left:10px">Claimants</span>
            </v-btn>
            <v-btn @click="showDets = true">
              <v-icon>mdi-comment-text-multiple-outline</v-icon>
              <span style="padding-left:10px">Details</span>
            </v-btn>
            <v-btn @click="showAttachs = true">
              <v-icon>mdi-attachment</v-icon>
              <span style="padding-left:10px">Attachments</span>
            </v-btn>
          </v-card-actions>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-toolbar color="grey darken-1" dark dense>
              <v-toolbar-title>
                <v-icon>{{claimIcon}}</v-icon>
                <span style="padding-left:10px">Claim Information</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
              <v-container fluid grid-list-lg class="mavContainer">
                <v-layout row wrap>
                  <v-flex sm6 xs12>
                    <v-flex class="ma-0 pa-0">
                      <v-subheader class="queryLabel">Claim Submission No.</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0">
                      <span class="title">{{clmSub.clmSubNo}}</span>
                    </v-flex>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-flex class="ma-0 pa-0">
                      <v-subheader class="queryLabel">Policy Holder Full Name as per NRIC / FIN / Passsport</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0">
                      <span class="title">{{clmSub.insdName}}</span>
                    </v-flex>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-text-field label="Proposal No." v-model="clmSub.propNo">
                      <v-btn slot="append-outer" icon @click="openProposalDialog(clmSub.propNo, null)">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </v-text-field>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-text-field :label="labels.polNo" v-model="clmSub.polNo" color="blue" :error-messages="errors.collect('polNo')"
                      data-vv-name="polNo" :data-vv-as="labels.polNo" v-validate="'required'" @blur="hasClaim();">
                      <v-btn slot="append-outer" icon @click="openProposalDialog(null, clmSub.polNo)">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </v-text-field>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <cal-picker v-model="clmSub.lossDate" label="Loss Date" :error-messages="errors.collect('lossDate')"
                      data-vv-name="lossDate" :data-vv-as="labels.lossDate" v-validate="lossDateValidation"
                      :min="minLossDate" :max="maxLossDate"/>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-flex class="ma-0 pa-0" v-if="clmSub.commDate && clmSub.expDate">
                      <v-subheader class="queryLabel">Period of Cover</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0">
                      <span class="title" v-if="clmSub.commDate && clmSub.expDate">{{formatDate(clmSub.commDate)}} - {{formatDate(clmSub.expDate)}}</span>
                    </v-flex>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <cal-picker v-model="clmSub.notDate" label="Notification Date" :error-messages="errors.collect('notDate')"
                      data-vv-name="notDate" :data-vv-as="labels.notDate" v-validate="notDateValidation" :max="new Date()" />
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-flex class="ma-0 pa-0">
                      <v-subheader class="queryLabel" v-if="clmSub.acceptDate">Policy Acceptance Date</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0" v-if="clmSub.acceptDate">
                      <span class="title">{{formatDate(clmSub.acceptDate)}}</span>
                    </v-flex>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <cal-picker v-model="clmSub.ackDate" label="Acknowledge Date" :error-messages="errors.collect('ackDate')"
                      data-vv-name="ackDate" :data-vv-as="labels.ackDate" v-validate="ackDateValidation" :min="clmSub.notDate" />
                  </v-flex>
                  <v-flex/>
                  <v-flex sm6 xs12>
                    <v-text-field v-model="clmSub.riskNo" :label="labels.riskNo" type="tel" :error-messages="errors.collect('riskNo')" data-vv-name="riskNo"
                      :data-vv-as="labels.riskNo" v-validate="'required|numeric|max_value:999|min_value:1'" v-num-mask="{intScale: 2, decScale: 0}"/>
                  </v-flex>
                  <v-flex/>
                  <v-flex xs12>
                    <v-text-field v-model="clmSub.cseLoss1" :label="labels.cseLoss1" :error-messages="errors.collect('cseLoss1')"
                      data-vv-name="cseLoss1" :data-vv-as="labels.cseLoss1" v-validate="'required|entry|max:35'"></v-text-field>
                    <v-text-field v-model="clmSub.cseLoss2" :label="labels.cseLoss2" :error-messages="errors.collect('cseLoss2') || errors.collect('cseLoss1')"
                      data-vv-name="cseLoss2" :data-vv-as="labels.cseLoss2" v-validate="'entry|max:35'"></v-text-field>
                    <v-text-field v-model="clmSub.cseLoss3" :label="labels.cseLoss3" :error-messages="errors.collect('cseLoss3') || errors.collect('cseLoss1')"
                      data-vv-name="cseLoss3" :data-vv-as="labels.cseLoss3" v-validate="'entry|max:35'"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="doProceed(false)">
                <v-icon>mdi-checkbox-marked</v-icon>
                Proceed
              </v-btn>
              <!--<v-btn color="yellow" @click="doProceed(true)">
                <v-icon>mdi-export</v-icon>
                Retrieve from Odyssey
              </v-btn>-->
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showProposals" width="1280px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Proposals
          <v-spacer></v-spacer>
          <v-btn flat icon @click="showProposals = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <form data-vv-scope="queryProposalFilterForm">
              <v-expansion-panel expand :value="[true]">
                <v-expansion-panel-content>
                  <div slot="header">
                    <v-icon>mdi-filter-variant</v-icon> Filters
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex lg6 xs12>
                            <v-text-field data-vv-scope="queryProposalFilterForm" v-int-mask="{intScale: 11}" v-model="filters.proposalNo" :label="filtersLabel.proposalNo" type="tel" :error-messages="errors.collect('proposalNo')" data-vv-name="proposalNo" :data-vv-as="filtersLabel.proposalNo" v-validate="'numeric'"></v-text-field>
                          </v-flex>
                          <v-flex lg6 xs12>
                            <v-text-field data-vv-scope="queryProposalFilterForm" v-model="filters.polNo" :label="filtersLabel.polNo" :error-messages="errors.collect('filterPolNo')" data-vv-name="filterPolNo" :data-vv-as="filtersLabel.polNo" v-validate="'entry|max:16'"></v-text-field>
                          </v-flex>
                          <v-flex lg6 xs12>
                            <cal-picker data-vv-scope="queryProposalFilterForm" v-model="filters.entryFrom" :label="filtersLabel.entryFrom" :data-vv-as="filtersLabel.entryFrom" data-vv-name="entryFrom" :error-messages="errors.collect('entryFrom')"></cal-picker>
                          </v-flex>
                          <v-flex lg6 xs12>
                            <cal-picker data-vv-scope="queryProposalFilterForm" v-model="filters.entryTo" :label="filtersLabel.entryTo" :data-vv-as="filtersLabel.entryTo" data-vv-name="entryTo" :error-messages="errors.collect('entryTo')"></cal-picker>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions right>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" flat="flat" @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </form>
          </v-flex>
          <v-flex xs12 class="mt-2">
            <v-data-table :headers="this.headers" :items="items" item-key="proposalNo" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" class="elevation-1" :rows-per-page-items="itemsPerPage" :no-data-text="noDataText">
              <template slot="items" slot-scope="props">
                <td>{{ props.item.proposalNo }}</td>
                <td>{{ props.item.polNo }}</td>
                <td>{{ props.item.intermediaryName }}</td>
                <td>{{ props.item.appName }}</td>
                <td>{{ props.item.createdDate }}</td>
                <td align='center'>
                  <v-btn icon slot="activator" color="primary" flat type="submit" @click.prevent="doSelectProposal(props.item)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showClmts" max-width="800px" lazy persistent>
      <claim-staging-clmts :clmSub="clmSub" @doClose="showClmts = false" />
    </v-dialog>
    <v-dialog v-model="showAttachs" max-width="800px" lazy persistent>
      <claim-staging-attachs :clmSub="clmSub" @doClose="showAttachs = false" />
    </v-dialog>
    <v-dialog v-model="showDets" max-width="800px" lazy persistent>
      <claim-staging-dets :clmSub="clmSub" @doClose="showDets = false" />
    </v-dialog>
    <v-dialog v-model="submitting" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Converting Claim. Please wait..
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </lazy-div>
</template>
<script>
import { appIcon } from '@/const/underwriting'
import { expandURI, filterQuery } from '@/utils/ajax'
import { removeTime, setEndTime, formatDisplayDateTime2, formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import ClaimStagingClmts from './ClaimStagingClmts'
import ClaimStagingDets from './ClaimStagingDets'
import ClaimStagingAttachs from './ClaimStagingAttachs'
import isAfter from 'date-fns/isAfter'
export default {
  data() {
    return {
      labels: {
        appID: 'Application Type',
        propNo: 'Proposal No.',
        polNo: 'Policy No.',
        lossDate: 'Loss Date',
        notDate: 'Notification Date',
        ackDate: 'Acknowledge Date',
        riskNo: 'Policy Benefit Section',
        acceptDate: 'Policy Acceptance Date',
        cseLoss1: 'Cause of Loss',
        cseLoss2: '',
        cseLoss3: ''
      },
      clmSub: {
        clmSubNo: undefined,
        polNo: undefined,
        propNo: undefined,
        insdName: undefined,
        lossDate: undefined,
        status: undefined,
        createdDate: undefined,
        ackDate: undefined,
        riskNo: undefined,
        acceptDate: undefined,
        commDate: undefined,
        expDate: undefined,
        cseLoss1: undefined,
        cseLoss2: undefined,
        cseLoss3: undefined,
        clmtDetStgs: [],
        types: []
      },
      minLossDate: undefined,
      maxLossDate: undefined,
      showProposals: false,
      headers: [
        { text: 'Proposal No.', align: 'left', value: 'proposalNo' },
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Intermediary', value: 'interName' },
        { text: 'Applicant Name', value: 'appName' },
        { text: 'Entry Date', value: 'createdDate' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      filtersLabel: {
        proposalNo: 'Proposal No.',
        polNo: 'Policy No.',
        entryFrom: 'Entry Date From',
        entryTo: 'Entry Date To'
      },
      filters: {
        proposalNo: null,
        polNo: null,
        entryFrom: null,
        entryTo: null
      },
      totalItems: 0,
      showClmts: false,
      showDets: false,
      showAttachs: false,
      submitting: false
    }
  },
  props: [
    'id'
  ],
  mounted() {
    this.fetchData()
  },
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    },
    async fetchData() {
      const apiUrl = this.menu.query
      try {
        const expand = {
          clmSubNo: this.id
        }
        const result = await this.$http.get(expandURI(apiUrl, expand))
        if (result.data) {
          const data = result.data
          this.clmSub = data
          if (!this.clmSub.ackDate) {
            this.clmSub.ackDate = new Date()
          }
        }
      } catch (error) {
        this.notify(error)
      }
    },
    openProposalDialog(propNo, polNo) {
      this.filters.polNo = polNo
      this.filters.proposalNo = propNo
      this.$nextTick(() => {
        this.showProposals = true
        this.fetchProposalsData()
      })
    },
    async fetchProposalsData() {
      const apiUrl = this.menu.getProposals
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: rowsPerPage
          }
          let messageFilters = {}
          messageFilters.entryFrom = this.filters.entryFrom ? formatDisplayDateTime2(removeTime(this.filters.entryFrom)) : undefined
          messageFilters.entryTo = this.filters.entryTo ? formatDisplayDateTime2(setEndTime(this.filters.entryTo)) : undefined
          messageFilters.polNo = this.filters.polNo
          messageFilters.proposalNo = this.filters.proposalNo
          messageFilters.appId = this.clmSub.appID
          let filterQ = filterQuery(expandURI(apiUrl, expand), messageFilters, this.pagination.sortBy, this.pagination.descending)
          const result = await this.$http.get(filterQ)
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.$set(this, 'items', data)
            } else {
              this.$set(this, 'items', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doSelectProposal(proposal) {
      this.clmSub.propNo = proposal.proposalNo
      this.clmSub.polNo = proposal.polNo
      this.clmSub.acceptDate = proposal.acceptDate
      this.clmSub.commDate = proposal.commDate
      this.clmSub.expDate = proposal.expDate
      this.minLossDate = proposal.commDate
      this.maxLossDate = proposal.expDate
      this.showProposals = false
      this.hasClaim()
      this.$validator.validate('lossDate', this.clmSub.lossDate)
      this.$validator.validate('polNo', this.clmSub.polNo)
    },
    async hasClaim() {
      const apiURI = this.menu.hasClaim
      const polNo = this.clmSub.polNo
      if (apiURI && polNo) {
        if (polNo !== undefined && polNo !== null && polNo !== '') {
          const expand = {
            polNo: polNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const error = {
              field: 'polNo',
              msg: 'A Claim has been filed for this Policy No.'
            }
            this.errors.add(error)
          }
        }
      }
    },
    doFilters() {
      this.resetMessages()
      // Reset to page 1
      this.pagination.page = 1
      this.fetchProposalsData(false)
    },
    doClearFilters() {
      this.filters.polNo = null
      this.filters.proposalNo = null
      this.filters.entryFrom = null
      this.filters.entryTo = null
      this.fetchProposalsData(false)
    },
    async doProceed(claimFromCore) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createIntimatedClaim(claimFromCore)
        } else {
          this.$snotify.error('Please check form input')
        }
      })
    },
    async createIntimatedClaim(claimFromCore) {
      this.submitting = true
      const apiUrl = this.menu.createIntimatedClaim
      if (apiUrl) {
        const clmSub = this.clmSub
        const form = {
          claimFromCore: claimFromCore,
          appID: clmSub.appID,
          clmSubNo: clmSub.clmSubNo,
          insdName: clmSub.insdName,
          polNo: clmSub.polNo,
          propNo: clmSub.propNo,
          lossDate: clmSub.lossDate,
          notDate: clmSub.notDate,
          ackDate: clmSub.ackDate,
          acceptDate: clmSub.acceptDate,
          expDate: clmSub.expDate,
          commDate: clmSub.commDate,
          riskNo: clmSub.riskNo,
          itemNo: clmSub.itemNo || 0,
          cseLoss1: clmSub.cseLoss1,
          cseLoss2: clmSub.cseLoss2,
          cseLoss3: clmSub.cseLoss3
        }
        const result = await this.$http.post(apiUrl, form)
        try {
          await this.$store.dispatch('claimListInit')
          const intClm = {
            clmRefNo: result.data.clmRefNo
          }
          await this.$store.dispatch('loadClaim', intClm)
          this.$router.push({ name: 'claimDetail' })
        } catch (err) {
          this.$snotify.error('Failed to convert claim.')
        }
      } else {
        this.$snotify.error('Invalid API Url (create intimated claim)')
      }
      this.submitting = false
    }
  },
  computed: {
    claimIcon() {
      return appIcon.TRAVEL
    },
    menu() {
      return this.$store.state.claimStaging.menu
    },
    lossDateValidation() {
      const result = 'required|claims_lossDate_comDate:' + this.minLossDate + '|claims_lossDate_expDate:' + this.maxLossDate
      return result
    },
    notDateValidation() {
      const result = 'required|claims_notDate_today'
      return result
    },
    ackDateValidation() {
      const result = 'required|claims_ackDate_notDate:' + this.clmSub.notDate
      return result
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchProposalsData(false)
    },
    'pagination.page': function (value) {
      this.fetchProposalsData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchProposalsData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchProposalsData(false)
    }
  },
  created() {
    this.$validator.extend('claims_lossDate_comDate', {
      getMessage(field, args) {
        return `The ${field} is not covered.`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var comDate = args[0]
          if (comDate) {
            if (isAfter(removeTime(comDate), removeTime(value))) return false
            else return true
          } else return true
        } else return true
      }
    })
    this.$validator.extend('claims_lossDate_expDate', {
      getMessage(field, args) {
        return `The ${field} is not covered.`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var expDate = args[0]
          if (expDate) {
            if (isAfter(removeTime(value), removeTime(expDate))) return false
            else return true
          } else return true
        } else return true
      }
    })
    this.$validator.extend('claims_notDate_today', {
      getMessage(field, args) {
        return `The ${field} cannot be later than Today.`
      },
      validate(value, args) {
        if (value) {
          if (isAfter(removeTime(value), removeTime(new Date()))) return false
          else return true
        } else return true
      }
    })
    this.$validator.extend('claims_ackDate_notDate', {
      getMessage(field, args) {
        return `The ${field} cannot be earlier than Notification Date.`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var notDate = args[0]
          if (notDate) {
            if (isAfter(removeTime(notDate), removeTime(value))) return false
            else return true
          } else return true
        } else return true
      }
    })
  },
  components: {
    ClaimStagingClmts: ClaimStagingClmts,
    ClaimStagingAttachs: ClaimStagingAttachs,
    ClaimStagingDets: ClaimStagingDets
  },
  mixins: [
    MessageMixin,
    TableConst.default
  ]
}
</script>
